const calculateRank = (rating, allRatings) => {
  if (!rating || allRatings.length === 0) return '-';

  const total = allRatings.length;
  
  // 1作品の場合は絶対評価
  if (total === 1) {
    if (rating >= 4.8) return 'S+';
    if (rating >= 4.5) return 'S';
    if (rating >= 4.0) return 'A';
    if (rating >= 3.5) return 'B';
    if (rating >= 3.0) return 'C';
    if (rating >= 2.5) return 'C-';
    return 'D';
  }

  // 平均と標準偏差を計算
  const mean = allRatings.reduce((sum, r) => sum + r, 0) / total;
  const variance = allRatings.reduce((sum, r) => sum + Math.pow(r - mean, 2), 0) / total;
  const stdDev = Math.sqrt(variance);

  // 標準偏差が非常に小さい場合（みんな同じような評価）は絶対評価基準を使用
  if (stdDev < 0.15) {
    if (rating >= 4.7) return 'S+';
    if (rating >= 4.3) return 'S';
    if (rating >= 3.8) return 'A';
    if (rating >= 3.3) return 'B';
    if (rating >= 2.8) return 'C';
    if (rating >= 2.3) return 'C-';
    return 'D';
  }

  // 平均からの偏差に基づいてランク決定
  const deviation = (rating - mean) / stdDev;

  // 偏差値的な考え方でランク分け
  // サンプル数に応じて閾値を調整
  let thresholds;
  if (total <= 5) {
    thresholds = { splus: 1.5, s: 0.8, a: 0.2, b: -0.2, c: -0.8, cminus: -1.3 };
  } else if (total <= 10) {
    thresholds = { splus: 1.4, s: 0.7, a: 0.1, b: -0.3, c: -0.7, cminus: -1.2 };
  } else if (total <= 20) {
    thresholds = { splus: 1.3, s: 0.6, a: 0.0, b: -0.4, c: -0.8, cminus: -1.3 };
  } else if (total <= 50) {
    thresholds = { splus: 1.2, s: 0.5, a: -0.1, b: -0.5, c: -0.9, cminus: -1.4 };
  } else {
    thresholds = { splus: 1.1, s: 0.4, a: -0.2, b: -0.6, c: -1.0, cminus: -1.5 };
  }

  if (deviation >= thresholds.splus) return 'S+';
  if (deviation >= thresholds.s) return 'S';
  if (deviation >= thresholds.a) return 'A';
  if (deviation >= thresholds.b) return 'B';
  if (deviation >= thresholds.c) return 'C';
  if (deviation >= thresholds.cminus) return 'C-';
  return 'D';
};

export default calculateRank;